/*
 * Announcement color sync
 * - Cor por anúncio: cada slide do announcement-bar pode ter sua própria cor (data-bar-color).
 * - Sincronizar com Slideshow: a barra assume a cor predominante da imagem do slide ativo do slideshow.
 * Segue o slide ativo real (MutationObserver em .swiper-slide-active), então funciona em qualquer timing.
 */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function luminance(r, g, b) {
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }
  function contrastText(r, g, b) {
    return luminance(r, g, b) > 150 ? '#1c0812' : '#ffffff';
  }

  function smallUrl(u) {
    if (!u) return u;
    if (/[?&]width=/.test(u)) return u.replace(/([?&]width=)\d+/, '$1140');
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=140';
  }

  function dominantFromImg(img) {
    try {
      var w = 28, h = 28;
      var c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data;
      var buckets = {}, best = null, bc = 0;
      for (var i = 0; i < d.length; i += 4) {
        if (d[i + 3] < 128) continue;
        var r = d[i], g = d[i + 1], b = d[i + 2];
        var key = (r >> 4) + '-' + (g >> 4) + '-' + (b >> 4);
        var bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
        bk.n++; bk.r += r; bk.g += g; bk.b += b;
        if (bk.n > bc) { bc = bk.n; best = bk; }
      }
      if (!best) return null;
      return [Math.round(best.r / best.n), Math.round(best.g / best.n), Math.round(best.b / best.n)];
    } catch (e) {
      return null;
    }
  }

  function loadColor(url, cb) {
    if (!url) { cb(null); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { cb(dominantFromImg(im)); };
    im.onerror = function () { cb(null); };
    im.src = smallUrl(url);
  }

  function parseColor(str) {
    if (!str) return null;
    var m = str.replace('#', '').trim();
    if (m.length === 3) m = m[0] + m[0] + m[1] + m[1] + m[2] + m[2];
    if (m.length < 6) return null;
    var r = parseInt(m.substr(0, 2), 16), g = parseInt(m.substr(2, 2), 16), b = parseInt(m.substr(4, 2), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
    return [r, g, b];
  }

  function apply(bar, rgb, textColor, autoContrast) {
    if (!rgb) return;
    bar.style.backgroundImage = 'none';
    bar.style.backgroundColor = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
    var tc = textColor || (autoContrast ? contrastText(rgb[0], rgb[1], rgb[2]) : null);
    if (tc) {
      bar.style.color = tc;
      bar.style.setProperty('--color-text', tc);
    }
  }

  function observeActive(root, cb) {
    if (!root) return;
    function current() { return root.querySelector('.swiper-slide-active'); }
    var mo = new MutationObserver(function () {
      var a = current();
      if (a) cb(a);
    });
    mo.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
    var a = current();
    if (a) cb(a);
  }

  function initBar(bar) {
    if (bar.dataset.colorSyncInit) return;
    bar.dataset.colorSyncInit = '1';

    var custom = bar.getAttribute('data-custom-colors') === 'true';
    var sync = bar.getAttribute('data-sync-slideshow') === 'true';
    var autoContrast = bar.getAttribute('data-auto-contrast') !== 'false';
    var trans = parseInt(bar.getAttribute('data-transition'), 10);
    if (isNaN(trans)) trans = 500;
    bar.style.transition = 'background-color ' + trans + 'ms ease, color ' + trans + 'ms ease';

    if (sync) {
      var ss = document.querySelector('slideshow-section.slideshow, .slideshow.swiper, .slideshow');
      if (ss) {
        var cache = {};
        var gifTimer = null;
        var gifImg = null;
        var runningGifKey = null;

        // Para o acompanhamento do GIF (limpa timer e remove a imagem oculta de amostragem)
        var stopGif = function () {
          if (gifTimer) { clearInterval(gifTimer); gifTimer = null; }
          if (gifImg && gifImg.parentNode) gifImg.parentNode.removeChild(gifImg);
          gifImg = null;
          runningGifKey = null;
        };

        // Largura moderada p/ performance, preservando o .gif (a Shopify mantém a animação ao redimensionar)
        var gifSampleUrl = function (u) {
          if (!u) return u;
          if (/[?&]width=/.test(u)) return u.replace(/([?&]width=)\d+/, '$1400');
          return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        };

        // Enquanto o GIF estiver ativo, reamostra a cor predominante a cada ~0,42s e atualiza a barra
        var startGifSync = function (url) {
          var im = new Image();
          im.crossOrigin = 'anonymous';
          im.decoding = 'async';
          im.setAttribute('aria-hidden', 'true');
          // fica no DOM (invisível) para o GIF animar de forma confiável em todos os navegadores
          im.style.cssText = 'position:fixed;left:0;top:0;width:2px;height:2px;opacity:0.001;pointer-events:none;z-index:-1;';
          var sampleGif = function () {
            var rgb = dominantFromImg(im);
            if (rgb) apply(bar, rgb, null, autoContrast);
          };
          im.onload = function () {
            sampleGif();
            gifTimer = setInterval(sampleGif, 420);
          };
          im.onerror = function () {
            // fallback: amostra única (comportamento anterior), sem regressão
            loadColor(url, function (rgb) { if (rgb) apply(bar, rgb, null, autoContrast); });
          };
          gifImg = im;
          document.body.appendChild(im);
          im.src = gifSampleUrl(url);
        };

        observeActive(ss, function (active) {
          var img = active.querySelector('img');
          if (!img) { stopGif(); return; }
          var key = img.currentSrc || img.src;
          var isGif = /\.gif(\?|$)/i.test(key) || /\.gif(\?|$)/i.test(img.getAttribute('src') || '');
          if (isGif) {
            if (gifTimer && runningGifKey === key) return; // já acompanhando este GIF
            stopGif();
            runningGifKey = key;
            startGifSync(key);
            return;
          }
          // imagem estática: cor única do slide (como antes)
          stopGif();
          if (cache[key]) { apply(bar, cache[key], null, autoContrast); return; }
          loadColor(key, function (rgb) {
            if (rgb) { cache[key] = rgb; apply(bar, rgb, null, autoContrast); }
          });
        });
        return; // sincronização tem prioridade sobre cor por anúncio
      }
    }

    if (custom) {
      var swiper = bar.querySelector('slide-section, .swiper');
      var root = swiper || bar;
      var hasSwiper = !!bar.querySelector('.swiper-slide');
      if (hasSwiper) {
        observeActive(root, function (active) {
          apply(bar, parseColor(active.getAttribute('data-bar-color')), active.getAttribute('data-text-color') || null, autoContrast);
        });
      } else {
        var el = bar.querySelector('[data-bar-color]');
        if (el) apply(bar, parseColor(el.getAttribute('data-bar-color')), el.getAttribute('data-text-color') || null, autoContrast);
      }
    }
  }

  onReady(function () {
    document.querySelectorAll('announcement-bar[data-color-sync]').forEach(initBar);
  });
})();
